export const WHATSAPP_NUMBER = "5511994304068";
export const WHATSAPP_DISPLAY = "(11) 99430-4068";
export const CONTACT_EMAIL = "contato@ambsolutions.com.br";

export const waLink = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const WHATSAPP_URL = waLink(
  "Olá! Vim pelo site da AMB Solutions e quero um diagnóstico inicial do meu negócio."
);

export const NAV_LINKS = [
  { label: "Soluções", href: "#solucoes" },
  { label: "Economize", href: "#economize" },
  { label: "Ferramentas", href: "#ferramentas" },
  { label: "Método", href: "#metodo" },
];

export const SERVICES = [
  {
    icon: "MessageCircle",
    name: "Automação de WhatsApp & E-mail",
    desc: "Atendimento automático 24h: responde dúvidas, qualifica o cliente e faz o follow-up sozinho. Sua equipe entra quando a venda está quente.",
    cta: "Olá! Quero automatizar o atendimento no WhatsApp e no e-mail.",
  },
  {
    icon: "Globe",
    name: "Criação de Sites",
    desc: "Sites e landing pages rápidos, bonitos no celular e feitos para transformar visita em conversa.",
    cta: "Olá! Quero um site para o meu negócio.",
  },
  {
    icon: "Bot",
    name: "Inteligência Artificial",
    desc: "Agentes de IA treinados no seu negócio para atender, tirar dúvidas, agendar e analisar dados, com o seu jeito de falar.",
    cta: "Olá! Quero entender como usar IA no meu negócio.",
  },
  {
    icon: "Workflow",
    name: "Automação de Processos & Integrações",
    desc: "Planilhas, CRM, pagamentos e agenda conversando entre si. Acaba o copia e cola e o retrabalho do dia a dia.",
    cta: "Olá! Quero automatizar processos e integrar meus sistemas.",
  },
  {
    icon: "Target",
    name: "Tráfego Pago & Marketing Digital",
    desc: "Campanhas no Google e Meta Ads com estratégia de funil e acompanhamento de resultado, para cada real investido trazer cliente.",
    cta: "Olá! Quero atrair mais clientes com tráfego pago.",
  },
];

export const FLAGSHIP_FEATURES = [
  "Atendimento e nutrição automáticos no WhatsApp e no e-mail",
  "Criação de sites e landing pages de alta conversão",
  "Automação de processos internos e rotinas repetitivas",
  "Integrações entre CRM, pagamentos e sistemas que você já usa",
];

export const ECONOMIA_BENEFICIOS = [
  {
    icon: "Clock",
    title: "Horas de volta para a equipe",
    desc: "Tarefas repetitivas passam a rodar sozinhas, 24h por dia. O time deixa de copiar, colar e responder o óbvio — e ganha tempo para vender e atender melhor.",
  },
  {
    icon: "Coins",
    title: "Menos custo operacional",
    desc: "Automação faz o trabalho de horas extras e de novas contratações para funções repetitivas. O mesmo time entrega mais, sem aumentar a folha.",
  },
  {
    icon: "ShieldCheck",
    title: "Menos erros e retrabalho",
    desc: "Dados digitados à mão geram falhas, cobranças erradas e clientes perdidos. Processos automatizados seguem a regra certa toda vez.",
  },
  {
    icon: "TrendingUp",
    title: "Escala sem improviso",
    desc: "Dobrou o volume de pedidos ou mensagens? A automação absorve o crescimento sem fila, sem atraso e sem estresse na operação.",
  },
];

export const ECONOMIA_TAREFAS = [
  { nome: "Responder dúvidas iniciais no WhatsApp", horas: 6, pct: 100 },
  { nome: "Follow-up de orçamentos e lembretes", horas: 4, pct: 66 },
  { nome: "Lançar dados entre planilhas e sistemas", horas: 3, pct: 50 },
  { nome: "Agendamentos e confirmações", horas: 3, pct: 50 },
  { nome: "Relatórios e fechamento semanal", horas: 2, pct: 33 },
];

export const PILLARS = [
  {
    num: "01",
    title: "Estratégia",
    desc: "Diagnóstico do cenário, da oferta e dos gargalos. Nenhuma linha de código antes de um plano claro.",
  },
  {
    num: "02",
    title: "Tecnologia",
    desc: "As ferramentas certas, integradas: site, automações e IA trabalhando como um só organismo.",
  },
  {
    num: "03",
    title: "Execução",
    desc: "Implementação acompanhada de perto, com ajustes contínuos até o resultado aparecer.",
  },
];

export const PORTFOLIO = [
  {
    title: "Plataforma de Atendimento Automatizado",
    category: "Automação + Web App",
    image:
      "https://images.unsplash.com/photo-1642132652860-471b4228023e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    title: "Ecossistema Digital de Vendas B2B",
    category: "Webdesign + Integrações",
    image:
      "https://images.unsplash.com/photo-1634084462412-b54873c0a56d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    title: "Portal de Inteligência com IA",
    category: "IA + Automação de Processos",
    image:
      "https://images.unsplash.com/photo-1630514969818-94aefc42ec47?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
];

export const FOOTER_AREAS = [
  "Automação de WhatsApp & E-mail",
  "Criação de Sites",
  "Inteligência Artificial",
  "Automação de Processos & Integrações",
  "Tráfego Pago & Marketing Digital",
];
